<script lang="ts">
        import type { ProductConfig } from '$lib/brand/types';

        interface Props {
                product: ProductConfig;
                refundsUrl: string;
                className?: string;
        }

        let { product, refundsUrl, className = '' }: Props = $props();

        const title = product.guarantee?.title ?? 'Our Satisfaction Promise';
        const description = product.guarantee?.description;
</script>

<div class="guarantee {className}">
        <h2>{title}</h2>
        {#if description}
                <p>{description.replace('{product.name}', product.name)}</p>
        {:else}
                <p>
                        We stand behind the quality of the {product.name}. Because it's a digital product delivered instantly,
                        we generally can't offer refunds once access is provided. But if something goes wrong — like failed
                        delivery, duplicate charges, or the product not matching its description — just reach out within 7 days
                        and we'll make it right. For full details, see our <a href="{refundsUrl}">Refund Policy</a>.
                </p>
                <p>
                        Your satisfaction matters to us, and we're here to support you if you have concerns.
                </p>
        {/if}
</div>

<style>
        .guarantee {
                background: #f8fafc;
                padding: 2rem;
                border-radius: 8px;
                border-left: 4px solid var(--brand-primary);
        }

        .guarantee h2 {
                font-size: 1.5rem;
                color: var(--brand-primary);
                margin-bottom: 1rem;
        }

        .guarantee p {
                color: #374151;
                line-height: 1.6;
                margin: 0 0 1rem 0;
        }

        .guarantee p:last-child {
                margin-bottom: 0;
        }
</style>
